import { createContext, useState, useEffect } from "react";

export const ThemeContext = createContext(0);

const ThemeProvider = ({ children }) => {
  const fromLS = JSON.parse(localStorage.getItem("theme"));

  const [theme, setTheme] = useState(fromLS === null ? 0 : fromLS);

  useEffect(() => {
    localStorage.setItem("theme", JSON.stringify(theme));
  }, [theme]);

  useEffect(() => {
    setTheme(JSON.parse(localStorage.getItem("theme")));
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
